export enum WeaveQualityType {
  CARPET = 'CARPET',
  VELVET = 'VELVET'
}
